<template>
  <div style="height: 100%; overflow-y: auto; padding-right: 10px">
    <!-- 筛选 -->
    <el-form :inline="true" :model="state.params" size="small">
      <el-form-item label="日期范围">
        <el-date-picker v-model="state.dateRange" type="daterange" range-separator="至" start-placeholder="开始" end-placeholder="结束" value-format="YYYY-MM-DD" @change="onSearch" />
      </el-form-item>
      <el-form-item label="券类型">
        <el-select v-model="state.params.Lx" placeholder="全部" clearable style="width: 120px" @change="onSearch">
          <el-option label="酒店" value="2" />
          <el-option label="门票" value="3" />
          <el-option label="联合套餐" value="4" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>

    <!-- 统计卡片 -->
    <el-row :gutter="16" style="margin-bottom: 16px">
      <el-col :span="4" v-for="card in state.cards" :key="card.label">
        <div class="stat-card">
          <div class="stat-value" :style="{ color: card.color }">{{ card.value }}</div>
          <div class="stat-label">{{ card.label }}</div>
        </div>
      </el-col>
    </el-row>

    <!-- 趋势图表区（使用简单表格模拟） -->
    <div class="chart-box">
      <div class="chart-title">领取/使用趋势（日维度）</div>
      <el-table :data="state.trend" border size="small" max-height="400" v-loading="state.trendLoading">
        <el-table-column label="日期" prop="Date" width="120" />
        <el-table-column label="主动发放" prop="IssueCount" width="100" align="center" />
        <el-table-column label="被动领取" prop="ReceiveCount" width="100" align="center" />
        <el-table-column label="使用量" prop="UsedCount" width="100" align="center" />
        <el-table-column label="合计" prop="TotalCount" width="100" align="center" />
      </el-table>
    </div>
  </div>
</template>

<script>
import { reactive, onMounted } from "vue";
import { youhuiquan_stats, youhuiquan_trend } from "@/http/api";

export default {
  setup() {
    const state = reactive({
      params: { Lx: "", Start: "", End: "" },
      dateRange: null,
      cards: [
        { label: "发放总量", value: 0, color: "#409EFF" },
        { label: "主动发放", value: 0, color: "#67C23A" },
        { label: "被动领取", value: 0, color: "#E6A23C" },
        { label: "领取率", value: "0%", color: "#909399" },
        { label: "使用量", value: 0, color: "#F56C6C" },
        { label: "核销率", value: "0%", color: "#909399" },
        { label: "优惠总额", value: "¥0", color: "#E6A23C" },
      ],
      trend: [],
      trendLoading: false,
    });

    onMounted(() => { onSearch(); });

    const onSearch = () => {
      const p = { ...state.params };
      if (state.dateRange && state.dateRange.length === 2) {
        p.Start = state.dateRange[0] + " 00:00:00";
        p.End = state.dateRange[1] + " 23:59:59";
      }

      youhuiquan_stats(p).then(res => {
        if (res.status === 200) {
          const d = res.data;
          state.cards[0].value = d.TotalIssue || 0;
          state.cards[1].value = d.TotalActiveIssue || 0;
          state.cards[2].value = d.TotalPassiveReceive || 0;
          state.cards[3].value = (d.ReceiveRate || 0) + "%";
          state.cards[4].value = d.TotalUsed || 0;
          state.cards[5].value = (d.VerifyRate || 0) + "%";
          state.cards[6].value = "¥" + (d.TotalYhJe || 0);
        }
      });

      state.trendLoading = true;
      youhuiquan_trend(p).then(res => {
        state.trendLoading = false;
        if (res.status === 200) {
          state.trend = (res.data || []).map(t => ({ ...t, Date: t.Date?.slice(0, 10) }));
        }
      }).catch(() => { state.trendLoading = false; });
    };

    return { state, onSearch };
  }
};
</script>

<style scoped>
.stat-card {
  background: #fff;
  border-radius: 8px;
  padding: 20px 16px;
  text-align: center;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
}
.stat-value { font-size: 28px; font-weight: 700; }
.stat-label { font-size: 13px; color: #999; margin-top: 8px; }
.chart-box {
  background: #fff; border-radius: 8px; padding: 20px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
}
.chart-title { font-size: 14px; font-weight: 600; margin-bottom: 12px; }
</style>
